var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Topbar',{attrs:{"title":_vm.versionName,"hasKeymap":""}}),_c('Main',[_c('PhoneticInput',{on:{"inputChanged":_vm.handleInputChange}}),_c('PhoneticOutput'),_c('PhoneticSuggestions')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }